
import React, { useRef, useState } from "react";
import { DocumentDashboardDTO, PatientHistoryItemDTO } from "../../../../../api/DashboardWidgetDTO";
import { useMediaQuery, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Avatar, IconButton, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, useTheme } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { REACT_APP_PUBLIC_API_URL } from "../../../../../KeyVariables";
import { handleDownload } from "./AnalyzisArchive";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileOpenIcon from '@mui/icons-material/FileOpen';

export interface ConsultsArchiveProps {
  items: PatientHistoryItemDTO[];
}

export const ConsultsArchive = ({ items }: ConsultsArchiveProps) => {
  const { t }: { t: any } = useTranslation('Portal');
  const iframeRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [openDialog, setOpenDialog] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState<DocumentDashboardDTO[]>([]);

  const handleOpenDialog = (documents: DocumentDashboardDTO[]) => {
    setSelectedDocuments(documents);
    console.log(documents)
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
           <TableRow>
          <TableCell>{t('Portal_CommonDate')}</TableCell>
          <TableCell>{t('Portal_CommonDoctor')}</TableCell>
          <TableCell>{t('Portal_CommonName')}</TableCell>
          <TableCell>{t('Portal_CommonDoc')}</TableCell>
        </TableRow>
        </TableHead>
        <TableBody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.date ? format(item.date, "dd.MM.yyyy HH:mm") : "-"}</TableCell>
                <TableCell>
                  {item.doctorDashboard?.image && (
                    <Avatar src={`${REACT_APP_PUBLIC_API_URL}/image/${item.doctorDashboard.image}`} sx={{ mr: 1 }} />
                  )}
                  {item.doctorDashboard?.name || "-"}
                </TableCell>
                <TableCell>{item.serviceDashboard?.name || "-"}</TableCell>
                <TableCell>
                  {item.documents?.length! > 0 ? (
                    <IconButton size="large" color="secondary" onClick={() => handleOpenDialog(item.documents!)}>
                      <AttachFileIcon />
                    </IconButton>
                  ) : (
                    "-"
                  )}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography>{t('Portal_NoConsults')}</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="lg">
        <DialogTitle>{t('Portal_DocumentsToDownload')}</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                {selectedDocuments.map((doc, index) => (
                  <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? "rgba(0, 0, 0, 0.04)" : "initial", cursor: 'pointer' }}
                    onClick={() => handleDownload(doc, "newtab")}>
                    <TableCell align="center">
                      <FileOpenIcon />
                    </TableCell>
                    <TableCell>
                      <Typography>{doc.name}</Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>{t('Portal_CommonClose')}</Button>
        </DialogActions>
      </Dialog>
    </TableContainer>
  );
};
